import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SubscriptionsService } from '../../infrastructure/services/subscriptions.service';
import { BuscadorPipe } from '../../helpers/pipes/buscador.pipe';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Subscription } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { SxContextService } from '../../infrastructure/services/sxContext.service';

@Component({
  templateUrl: './listado.subscriptions.component.html',
})
export class ListadoSubscriptionsComponent implements OnInit, OnDestroy {
  subscriptions: Observable<ItemGeneralListado[]>;
  ocultarNuevo = false; // define si debo o no mostrar el boton Nuevo

  constructor(private router: Router,
              private aRoute: ActivatedRoute,
              private sxContextService: SxContextService,
              private subscriptionsService: SubscriptionsService) { }

  ngOnInit() {
    const { ocultarNuevo } = this.aRoute.snapshot.data;
    this.ocultarNuevo = ocultarNuevo;
    this.subscriptions = this.subscriptionsService.getForList();

      // Si tengo un sistema por defecto, redirecciono directamente a la home
      if (this.sxContextService.getContexto(false)) {
        this.router.navigate(['/soc', this.sxContextService.getContexto(true)]);
        return;
      }
  }

  ngOnDestroy() {
    
  }

  navegarNuevaSubscription() {
    this.router.navigate(['soc/backoffices/nuevo/edit']);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/listado.subscriptions.component.ts